export default __webpack_public_path__ + "static/media/git.feb061b9.svg";